import { render, staticRenderFns } from "./EmployeeFeatureForm.vue?vue&type=template&id=80a921bc"
import script from "./EmployeeFeatureForm.vue?vue&type=script&lang=js"
export * from "./EmployeeFeatureForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports